import spartaDefensiveCheck from "utilities/global/sparta-defensive-check-utility/1.3.0/js/sparta-defensive-check-utility";
import Handlebars from "utilities/vendor/handlebars/4.7.8/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.8/js/handlebars";
import badgingHelper from "utilities/helpers/helpers-badging/1.0.3/js/helpers-badging";
import spartaBadgingHelper from "utilities/helpers/helpers-badging/1.0.3/js/helpers-badging";
import SpartaBadgingHelper from "utilities/helpers/helpers-badging/1.0.3/js/helpers-badging";
import svgHelper from "utilities/helpers/helpers-svg/4.0.2/js/helpers-svg";



const UTILITY_NAME = 'helpers/helpers-button';
const VALID_BREAKPOINT_KEYS = [
  'small-up',
  'medium-up',
  'large-up',
  'small-only',
  'medium-only',
  'large-only',
];
const VALID_TAGS = ['button', 'a'];
const DEFAULT_TAG = 'button';
const DEFAULT_BASE_CLASS = 'spa-btn';
const VALID_TYPE_ATTRIBUTES = ['button', 'submit', 'reset'];
const VALID_BTN_TEXT_ICON_MODIFIERS = ['small', 'large', 'disabled'];
const REQUIRED_BUTTON_ATTRIBUTE_KEYS = ['type'];
const ACTION_MODIFIERS = {
  layer: 'spa-ui-layer-link spa-fn',
  popup: 'spa-fn spa-boa-window'
};
const ACTION_LAYER_MODIFIERS = {
  interstitialType: 'spa-ui-layer-interstitial',
  inputHelpLinkType: 'toggle-trigger-link',
  inputHelpIconType: 'toggle-trigger svg-button',
  layerType: 'spa-ui-layer-tooltip-link',
};

const helpers = {

  button(config, secureHost) {
    let output = '';
    if (
      spartaDefensiveCheck.truthyObject(
        config,
        'helpers-button:button:config should be of object type for building sites'
      )
    ) {



      const baseExists = Object.prototype.hasOwnProperty.call(config, 'base');
      const baseIsValid = (baseExists && (config.base === '' || config.base.length));
      const BASE_CLASS = (baseIsValid) ? config.base : DEFAULT_BASE_CLASS;

      const BTN_PREFIX = `${BASE_CLASS}--`;
      const ADDITIONAL_CLASSES = config.classes || '';

      let modifierClasses = '';
      let attributes = '';
      let content = config.content || '';
      let EXCLUDE_ROLE_ATTRIBUTE_KEY = [];

      let badging = '';
      let ariaPressed = ''; 
      let contentLeft = '';
      let contentRight = '';
      const BTN_TEXT_ICON = `${BASE_CLASS}-icon`;


      const TAG = (VALID_TAGS.indexOf(config.tag) !== -1) ? config.tag : DEFAULT_TAG;
      const isButton = TAG === 'button';

      const EXISTING_ATTRIBUTE_KEYS = (config.attributes) ? Object.keys(config.attributes) : [];
      const REQUIRED_ATTRIBUTE_KEYS = (isButton) ? REQUIRED_BUTTON_ATTRIBUTE_KEYS : [];

      const isTextIcon = config.iconTextPattern || '';



      if (config.modifiers) {

        config.modifiers.split(' ').forEach((keyword) => {
          if (!isTextIcon || VALID_BTN_TEXT_ICON_MODIFIERS.indexOf(keyword) !== -1) {
            modifierClasses += `${BTN_PREFIX}${keyword} `;
          }
        });
      }


      if (config.breakpoints) {

        VALID_BREAKPOINT_KEYS.forEach((breakpoint) => {
          const keywords = config.breakpoints[breakpoint];

          if (keywords) {
            keywords.split(' ').forEach((keyword) => {
              modifierClasses += `${BTN_PREFIX}${keyword}-at-${breakpoint} `;
            });
          }
        });
      }



      if (config.actionType) {
        const type = config.actionType.type;
        const options = config.actionType.options;


        attributes += 'data-bactmtrack ';

        if (options) {

          let stringifiedOptions = JSON.stringify(config.actionType.options);
          let escapedOptions = Handlebars.Utils.escapeExpression(stringifiedOptions);
          attributes += `data-options="${escapedOptions}" `;
        }



        const typeSwitch = {
          layer() {
            if (options) {
              if (options.rel) {
                attributes += `rel="${options.rel}" `;
              }


              Object.keys(ACTION_LAYER_MODIFIERS).some((key) => {
                if (options.hasOwnProperty(key)) {
                  modifierClasses += ACTION_LAYER_MODIFIERS[key] + ' ';
                  return true;
                }
                return false;
              });
            }
          },
        };

        if (type) {

          if (ACTION_MODIFIERS.hasOwnProperty(type)) {
            modifierClasses += ACTION_MODIFIERS[type] + ' ';
          }

          if (typeSwitch[type]) {
            typeSwitch[type]();
          }
        }
      } else if (config.adaText) {

        content += `<span class="spa-ada-text ada-hidden">&nbsp;${config.adaText}</span>`;    
      }


      if (TAG === 'a') {
        EXISTING_ATTRIBUTE_KEYS.forEach((attr) => {
          if (attr === 'target') {
            if (config.attributes && config.attributes[attr] === '_blank') {
              if (config.actionType && config.actionType.options && config.actionType.options.rel) {
                attributes += `rel="${config.actionType.options.rel} noopener noreferrer" `;
              } else {
                attributes += `rel="noopener noreferrer" `;
              }
            }
          }
        });
      }


     if (config.icon && isTextIcon) {
      const iconTextObj = config.icon;
      const isObjectButtonTextIcon = spartaDefensiveCheck.truthyObject(iconTextObj,'helpers-button:config.icon should be of object type for button text icon');
      if (isObjectButtonTextIcon) {
        const iconNameValue = iconTextObj.name ? iconTextObj.name : ''; 
        const iconPosition = iconTextObj.position ? iconTextObj.position : 'left';
        modifierClasses += `${BTN_TEXT_ICON} ${BTN_TEXT_ICON}--${iconPosition} `;

        if (config.selected) {
          ariaPressed = 'aria-pressed="true"'; 
          modifierClasses += `${BTN_TEXT_ICON}--selected `;
        }


        if (config.badging) {
          modifierClasses += 'spa-btn-icon--has-badge';
          config.badging.options = config.badging.options || {};
          config.badging.options.position = 'relative';
          badging = badgingHelper.render(config.badging);
        }

        const iconDataJcr = {
          type: "static",
          iconName: iconNameValue,
          classes: 'spa-btn-text-icon',
          focusable: 'false',
          ariaHidden: true
        };
        const iconMarkup = Handlebars.compile(`{{svgHelper data}}`)({data:iconDataJcr});

        if (iconPosition === 'right') {
          contentRight = `${iconMarkup}`;
          contentLeft = `${badging}`;
        } else {
          contentRight = `${badging}`;
          contentLeft = `${iconMarkup}`;
        }
      }
     }


      REQUIRED_ATTRIBUTE_KEYS.forEach((attr) => {
        if (EXISTING_ATTRIBUTE_KEYS.indexOf(attr) === -1) {
          EXISTING_ATTRIBUTE_KEYS.push(attr);
        }
      });


      EXCLUDE_ROLE_ATTRIBUTE_KEY = EXISTING_ATTRIBUTE_KEYS.filter((val) => val.indexOf('role') < 0);


      EXCLUDE_ROLE_ATTRIBUTE_KEY.forEach((attr) => {
        let val = (config.attributes && config.attributes[attr]) ? config.attributes[attr] : undefined;

        if (isButton) {
          if (attr === 'type') {

            if (VALID_TYPE_ATTRIBUTES.indexOf(val) === -1) {
              val = 'button';
            }
          }
        }


        if (Object.prototype.hasOwnProperty.call(config, 'secure') && config.secure === true) {
          if (!config.attributes || !config.attributes.href) {
            throw new Error(`Error in ${UTILITY_NAME}: 'config.attributes' is missing an 'href' property.`);
          } else if (attr === 'href') {
            if (!/^http.+/i.test(val)) {
              if ((!secureHost || typeof secureHost !== 'string')) {
                if (typeof spaParams !== 'undefined' && spaParams.siteParams) {
                  secureHost = spaParams.siteParams.secureHost;
                } else {
                  throw new Error(`Error in ${UTILITY_NAME}: secureHost is not defined and is necessary for secure link button.`);
                }
              }

              val = secureHost + val;
            }
          }
        }


        attributes += `${attr}="${val}" `;
      });


      const CLASSES = `class="${BASE_CLASS} ${modifierClasses} ${ADDITIONAL_CLASSES}"`;


      attributes = `${CLASSES} ${attributes}`;




      output = `<${TAG} ${config.vueOptionsStr || ''}  ${attributes} ${ariaPressed}>${contentLeft}${content}${contentRight}</${TAG}>`;

    } else {
      const msg = `Error in ${UTILITY_NAME}: 'button' helper method requires a config. ` +
        `If you are using multiple languages ensure all language-based JCRs have the same named config property.`;
      throw new Error(msg);
    }


    return new Handlebars.SafeString(output);
  },
};





class ButtonHelper {





  static register(Handlebars) {
    Object.keys(helpers).forEach((key) => {
      Handlebars.registerHelper(key, helpers[key]);
    });
  }
}

module.exports = ButtonHelper;
